<template>
<div class="agreement-text">
	<!-- <p ><h2 class="tc">【投保须知】</h2></p>

        <p><b>一.基本产品信息</b></p>

        <p>（一）本保险产品为个人借款保证保险，由众安在线财产保险股份有限公司（以下可简称“众安保险”）承保，众安保险总部设立于上海，在全国不设分支机构。本产品通过互联网在全国区域销售。</p>

        <p>（二）本保险产品适用的保险条款为<a ></a><a >《众安在线财产保险股份有限公司个人借款保证保险条款（贷款机构版）(</a><a id="_anchor_1" href="#_msocom_1" language="JavaScript" name="_msoanchor_1"></a> <a id="_anchor_2" href="#_msocom_2"  name="_msoanchor_2"></a> 报备文件编号为（众安在线)(备-保证保险)【2017】(主)016号）。</p>

        <p>（三）本保险产品的投保人为中华人民共和国境内（不包含香港、澳门及台湾地区）、年龄为18周岁（含）<a ></a><a >-65周岁（含）</a><a id="_anchor_3" href="#_msocom_3"  name="_msoanchor_3"></a> <a id="_anchor_4" href="#_msocom_4"  name="_msoanchor_4"></a> 且具有完全民事行为能力的自然人。</p>

        <p>（四）本保险产品的被保险人为与投保人签署合法有效的借款合同的贷款人。</p>

        <p><b>二.保费缴纳方式</b></p>

        <p><a ></a><a ></a>本保险产品的保费缴纳方式为期交，由保险人根据投保人的授权委托支付机构在约定的还款日进行当期保费代扣。<a id="_anchor_5" href="#_msocom_5"   name="_msoanchor_5"></a> <a id="_anchor_6" href="#_msocom_6"  name="_msoanchor_6"></a> </p>

        <p><b>三.保单及发票形式</b></p>

        <p><b>保单形式：</b>本保险产品提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。您可以登录 <a href="http://www.zhongan.com">www.zhongan.com</a> 自助查询，对电子保单的真实性进行验证。</p>

        <p><b>发票形式：</b>本保险产品提供电子发票，您可以在通过 <a href="http://www.zhongan.com">www.zhongan.com</a> 自助查询保单时，点击“索要发票”按钮索取电子发票。电子发票与纸质发票具有同等效力。</p>

        <p>如您需纸质保单和发票，请致电众安客服电话：400-999-9595 或 1010-9955。同时您需提供寄送地址以便我司向您寄送，<b>但相应的快递费用将由您承担</b>。快递收费标准请参考中国邮政速递物流，若快递公司调整收费标准的，我司保留调整快递费用的权利。</p>

        <p><b>四．投保人如实告知义务</b></p>

        <p>请您了解，在投保本产品前您应履行相应的如实告知义务，具体如下：</p>

        <p>投保人或被保险人应如实填写投保信息，并就保险公司提出的询问据实告知,否则保险公司有权根据《中华人民共和国保险法》第十六条的规定解除保险合同且不承担赔偿责任：订立保险合同时，保险公司就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。</p>

        <p><b>投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同。</b></p>

        <p><b>投保人故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。</b></p>

        <p><b>投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，但退还保险费。</b></p>

        <p><b>五．偿付能力及理赔服务</b></p>
        <p>（1）偿付能力：众安保险最近季度偿付能力符合监管要求，详情请参见众安保险官网（www.zhongan.com）偿付能力信息披露。</p>
        <p>（2）理赔服务：本保险产品采用自动理赔的方式，发生保险事故后，众安保险将自行搜集索赔所需的相关材料，无需被保险人再行提供。众安保险将在借款逾期后的四个工作日内，将理赔款支付至被保险人的账户内。如对理赔过程有任何疑问，您可拨打众安保险7 x 12小时客服热线：400-999-9595 或 1010-9955进行咨询。</p>

        <p><b>六．合同咨询及变更</b></p>

        <p>如您需要咨询本保险产品的相关信息或变更保险合同，请拨打众安客服热线：400-999-9595 或 1010-9955。</p>

        <p><b>七. 个人隐私保护</b></p>

        <p>众安保险严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制 度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。您还可以登录众安保险官网：<a href="http://www.zhongan.com">www.zhongan.com</a>查阅众安隐私声明。</p>

        <p><b>【投保声明】</b></p>

        <p><b>1. 本人同意在申请借款时自愿投保个人借款保证保险。</b></p>

        <p>2. 本人已完整阅读并了解以上投保须知及投保险种的保险条款，尤其是对其中免除保险人责任的条款或约定（<b>包括但不限于责任免除、免赔额、投保人被保险人义务、赔偿处理等</b>），本人已充分理解并接受上述内容，同意以此作为订立保险合同的依据。</p>

        <p>3. 投保时，本人已明确知晓该产品的保障内容以及保险金额、保费/保险费率、保险期限等相关内容。</p>

        <p><a ></a><a >4. 本人已知晓本产品一旦生效不允许退保。</a><a id="_anchor_9" href="#_msocom_9"  name="_msoanchor_9"></a> <a id="_anchor_10" href="#_msocom_10"  name="_msoanchor_10"></a> </p>

        <p>5. 本人同意贵公司为本保险及与本保险之相关服务的目的收集本人的个人资料，无论该资料是从本投保申请或其他地方所获取。本人理解贵公司为提升保险服务质量，可能会与第三方机构、组织或个人合作，此类合作可能需要使用本人的个人资料。在此理解下， 本人同意并授权贵公司及与贵公司存在合作关系的机构、组织或个人将收集的本人的个人资料用于：（1）该保险的投保审核；（2）该保险的理赔；（3）提供与该保险有关之服务；（4）与本人联络。</p> -->
	<h2 class="tc">投保须知</h2>
	<p><strong><strong>一、基本产品信息</strong></strong></p>
	<p>（一）本保险产品名称为<span>个人借款保证保险</span>，由众安在线财产保险股份有限公司（以下可简称&ldquo;众安保险&rdquo;或&ldquo;我司&rdquo;）承保。<strong><strong>众安保险总部设立于上海，通过互联网在中华人民共和国境内（港、澳、台地区除外）开展与互联网交易直接相关的保险业务，主要服务会通过电话、互联网上的服务、第三方服务机构等方式为您提供全面便捷的保险服务。欢迎拨打公司7*24客服热线：400-999-9595&nbsp;或&nbsp;1010-9955。众安保险不设分支机构，在您所在的地区，可能无法直接提供及时的面对面线下服务。</strong></strong></p>
	<p>（二）本保险产品适用的保险条款为《<u>&nbsp;</u>众安在线财产保险股份有限公司个人借款保证保险条款（贷款机构版）(报备文件编号为（众安在线)(备-保证保险)【2017】(主)016号）》；您可以登录众安保险官方网站：<a href="http://www.zhongan.com"><u>www.zhongan.com</u></a>，查阅具体条款内容。</p>
	<p>（三）投保人：凡与被保险人订立合法、有效的借款合同且具有完全民事行为能力的自然人，可以作为本保险合同的投保人。</p>
	<p>（四）被保险人：在中华人民共和国境内合法设立的，具有放款资质的银行、小额贷款公司、信托公司、消费金融公司等机构均可作为本保险的被保险人。</p>
	<p>（五）保险费率：详见投保页面展示，具体以保险合同约定为准。</p>
	<p><strong><strong>（六）责任免除条款： </strong></strong></p>
	<p><strong><strong>因发生下列任一情形导致的损失或责任，保险人不承担赔偿责任：</strong></strong></p>
	<p>如被保险人负责审核借款合同真实有效性的，因被保险人原因导致借款合同被依法认定无效或被撤销的；</p>
	<p>投保人与被保险人采用欺诈、串通等恶意手段订立借款合同的；</p>
	<p>未经保险人事先同意，投保人、被保险人擅自变更借款合同及其附件的；</p>
	<p>非投保人原因导致的行政行为或司法行为；</p>
	<p>地震、海啸或其他人力不可抗拒的自然灾害导致不能还款的。</p>
	<p>对下列损失、费用和责任，保险人不负责赔偿：</p>
	<p>除借款合同中所约定的本金、利息以外的任何费用；</p>
	<p>任何形式的间接损失；</p>
	<p>保险合同中载明的免赔额。</p>
	<p><strong><strong>其他不属于保险合同责任范围内的损失和费用，保险人均不负责赔偿。</strong></strong></p>
	<p>保险责任、保险免责条款及其他保险相关内容，详见《众安在线财产保险股份有限公司个人借款保证保险条款（贷款机构版）(众安在线)(备-保证保险)【2017】(主)016号》。本投保须知未涉及之处，以保险条款为准。</p>
	<p>（七）特别说明事项 ：</p>
	<p>您可通过登录中国保险行业协会官网，查阅众安在线保险股份有限公司合作第三方网络平台<strong><strong>在中保协网站</strong></strong>的披露信息：<a href="http://icid.iachina.cn/">http://icid.iachina.cn/</a>。</p>
	<p><strong><strong>二、保险费的支付方式</strong></strong></p>
	<p>本保险产品的保费缴纳方式为期缴，由保险人根据投保人的授权委托支付机构在约定的还款日进行当期保费代扣，或投保人主动付款至保险人指定账户。</p>
	<p><strong><strong>三、保险合同订立方式及发票形式</strong></strong></p>
	<p><strong><strong>（一）保险合同订立方式</strong></strong><strong><strong>：</strong></strong><strong><strong>我司通过互联网方式与您订立保险合同，</strong></strong><strong><strong>本保险</strong></strong><strong><strong>产品</strong></strong><strong><strong>提供电子保单。</strong></strong>根据《中华人民共和国合同法》第十条、第十一条的规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。您可以登录
		<a href="http://www.zhongan.com"><u>www.zhongan.com</u></a>&nbsp;自助查询电子保单。</p>
	<p><strong><strong>（二）发票</strong></strong><strong><strong>形式</strong></strong><strong><strong>：</strong></strong>本保险产品提供电子发票，您可以在通过&nbsp;<a href="http://www.zhongan.com"><u>www.zhongan.com</u></a>&nbsp;自助查询保单时，点击&ldquo;索要发票&rdquo;按钮索取电子发票。电子发票与纸质发票具有同等效力。</p>
	<p>（三）如您需纸质保单和发票，请致电众安保险客服电话：<u>400-999-9595</u><u>&nbsp;</u>或 <u>1010-9955</u>。同时您需提供寄送地址以便我司向您寄送，<strong><strong>但</strong></strong><strong><strong>相应的快递费用将由您承担</strong></strong>。快递收费标准请参考中国邮政速递物流，若快递公司调整收费标准的，我司保留调整快递费用的权利。</p>
	<p><strong><strong>四、投保人的如实告知义务</strong></strong></p>
	<p><strong><strong>（一）投保人或被保险人应如实填写投保信息，并就保险公司提出的询问据实告知,否则保险公司有权根据《中华人民共和国保险法》第十六条的规定解除保险合同且不承担赔偿责任：订立保险合同时，保险公司就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。</strong></strong></p>
	<p><strong><strong>（二）投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同。</strong></strong></p>
	<p><strong><strong>投保人故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。</strong></strong></p>
	<p><strong><strong>（三）投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，但退还保险费。</strong></strong></p>
	<p><strong><strong>五、保险服务流程</strong></strong></p>
	<p>（一）投保流程：</p>
	<p>投保人主动向众安保险发起申请并同意以数据电文形式订立投保相关协议，即代表投保人向众安保险发起投保申请。</p>
	<p>（二）承保流程：</p>
	<p>众安保险对投保人的投保申请进行核保，核保通过后进行承保并出具电子保单，保险人生成的保险单等文件均作为保险合同的有效组成部分。</p>
	<p>（三）退保流程及退保金的支付方式：</p>
	<p>根据《众安在线财产保险股份有限公司个人借款保证保险条款（贷款机构版）(众安在线)(备-保证保险)【2017】(主)016号》，在保险合同有效期内，未全额清偿借款本息前，投保人不得退保。投保人提前全额清偿借款本息的，保险合同终止，保险人不退还保费。</p>
	<p>（四）理赔流程及保险金的支付方式：</p>
	<p>&nbsp;&nbsp;在保险期间内，投保人未能按照与被保险人签订的借款合同中的约定履行还款义务，且投保人拖欠任何一期欠款超过保险合同约定的期限仍未足额还款的，则保险人对投保人未偿还的借款本金或/和利息按照保险合同的约定承担赔偿责任。</p>
	<p>为确保被保险人的保险权益，众安保险在收到被保险人或其通过被保险人的授权方传递的借款逾期信息后，即自动启动保险理赔程序，根据保险合同约定向被保险人支付保险金。</p>
	<p>众安保险将保险金支付至被保险人指定的理赔款收款账户（具体见保险合同约定），即视为已经向被保险人支付了保险金。</p>
	<p>（五）众安保险客服热线：1010-9955或400-999-9595；众安保险投诉热线：021-80399188；</p>
	<p>（六）如您需要咨询本保险产品的相关信息或变更保险合同，请拨打上述众安保险客服热线。</p>
	<p><strong><strong>六、偿付能力</strong></strong></p>
	<p>众安保险偿付能力充足率符合监管要求，具体最新偿付能力情况，请参见众安保险官网：www.zhongan.com。</p>
	<p><strong><strong>七、个人隐私保护</strong></strong></p>
	<p>众安保险严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我司的个人信息、数据和投保交易信息不受到非法的泄露或披露给未获授权的第三方，并保障您的投保交易安全。您还可以登录众安保险官网：<a href="http://www.zhongan.com"><u>www.zhongan.com</u></a>&nbsp;查阅众安保险的隐私声明。</p>
	<p><strong><strong>八、投保人声明</strong></strong></p>
	<p class="fwbd">您已完整阅读以上投保须知及投保险种的保险条款，尤其是对有关保险责任条款、免除责任条款、退保规则、投保人和被保险人权利义务、理赔处理等重大事项;投保时，您已明确知晓并同意本保险产品的保险标的、保险金额、保险费率、保险期限等相关内容。您已经充分理解以上内容并同意订立保险合同。</p>

</div>
</template>

<script>
export default {
	beforeRouteEnter(to, from, next) {
		document.title = '投保须知投保声明'
		next()
	}
}
</script>



// WEBPACK FOOTER //
// covertext.vue?fbfbb36a